export default __webpack_public_path__ + "static/media/3.c0007b22.svg";